import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 16 11",
  "content": "<symbol viewBox=\"0 0 16 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\">\n<path d=\"M5.53125 10.2812C5.6875 10.1562 5.75 9.96875 5.75 9.75C5.75 9.5625 5.6875 9.375 5.53125 9.25L2.5625 6.25H15.25C15.6875 6.25 16 5.9375 16 5.5C16 5.09375 15.6875 4.75 15.25 4.75H2.5625L5.53125 1.78125C5.84375 1.5 5.84375 1.03125 5.53125 0.75C5.25 0.4375 4.78125 0.4375 4.46875 0.75L0.21875 5C-0.0625 5.28125 -0.0625 5.75 0.21875 6.03125L4.46875 10.2812C4.78125 10.5938 5.25 10.5938 5.53125 10.2812Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/arrow.svg
// module id = hv89
// module chunks = 13